import * as React from 'react';
import { observer } from 'mobx-react';
import { Tooltip } from '@iba-team/portal-react-components/dist';
import { EmployeeEvent } from '../../types';

export interface CellProps{
  event: EmployeeEvent
  setSelectedRange:  (toggle: 'DELETE' | 'ADD') => void ,
  selectedRange: EmployeeEvent[],
  currentMode: 'DELETE' | 'ADD' | undefined,
  isYourCell: boolean,
  actionClassName?: string,
  plannedCellClassName?: string,
}



export const EmptyCell = observer(({ event, selectedRange, setSelectedRange, currentMode, isYourCell, actionClassName}: CellProps) => {
  const onClick = () => {
    setSelectedRange('ADD');
  };

  const isFirstChild = selectedRange[0]?.startDate === event.startDate;

  const renderFirstChildBorder = () => {
    return `first-child-in-list-${currentMode?.toLowerCase()}`;
  };

  const renderTooltipTitle = () => {
    if (!isYourCell){
      return undefined;
    }

    if(selectedRange.length){
      if(new Date(event.startDate) < new Date(selectedRange[0]?.startDate)){
        return '';
      } else if(currentMode === 'DELETE'){
        return (<div>Click to delete <br/> planned absence</div>);
      } else if(currentMode === 'ADD'){
        return 'Click to set end day';
      }
    }

    if(new Date(event.startDate) < new Date()){
      return '';
    }

    return 'Click to add planned absence';
  };

  return(
    <div className={`default_cell_container ${actionClassName} ${isFirstChild && renderFirstChildBorder()}`}>
      <div className={'drag_container_empty'} onClick={() => onClick()}>
        <Tooltip title={renderTooltipTitle()}>

        </Tooltip>
      </div>
    </div>
  );
});
